import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
import { AddLiabilityComponent } from '../add-liability/add-liability.component';


@Component({
  selector: 'app-liabilities-array',
  templateUrl: './liabilities-array.component.html',
  styleUrls: ['./liabilities-array.component.scss']
})
export class LiabilitiesArrayComponent implements OnInit {
	@Input() public liabilitiesArray: FormArray;
	@Input() public displayErrors: boolean;
	@Input() public qID: string;
	@Output() onAddFormGroup: EventEmitter<any> = new EventEmitter<any>();
	
	maxLiabilitieCount = 4;
  constructor() { }

	ngOnInit() {
	}

	addLiability() {
		this.displayErrors = this.liabilitiesArray.invalid;
		if (this.liabilitiesArray.valid)
		{
			this.liabilitiesArray.push(AddLiabilityComponent.buildLiability(''));
			this.onAddFormGroup.emit();
			
		}
	}

	simulateClick(event) {
		if ( event.keyCode === 13 ){
			event.currentTarget.click();
		} 
	}
	 
  static buildLiabilities(value:any) {
	let arr: FormGroup[]=[];
	if(value && value.length > 0){
		value.forEach(element => {
			arr.push(AddLiabilityComponent.buildLiability(element));
		});
	}
	else{
		arr.push(AddLiabilityComponent.buildLiability(''));
	}
	return new FormArray(arr);
  }
}



// WEBPACK FOOTER //
// ./src/app/liabilities-array/liabilities-array.component.ts